import lodash from 'lodash'
import React from 'react'
import styled from 'styled-components'

import Checkbox from '../../../../../../../1stlog-ui/src/components/Checkbox'

const Wrapper = styled.div``

const YesNoSelect = (props) => {
  const { value, onChange } = props

  const onYes = () => onChange(value === true ? undefined : true)

  const onNo = () => onChange(value === false ? undefined : false)

  return (
    <Wrapper className="d-flex mt-1">
      <div>
        <Checkbox value={value === true} onChange={lodash.noop} onClick={onYes}>
          {i18n.t('yes', 'Ja')}
        </Checkbox>
      </div>
      <div>
        <Checkbox value={value === false} onChange={lodash.noop} onClick={onNo}>
          {i18n.t('no', 'Nein')}
        </Checkbox>
      </div>
    </Wrapper>
  )
}

export default YesNoSelect
